var map = {
	"./HasteModuleLoader": 113,
	"./HasteModuleLoader.js": 113,
	"./__tests__/HasteModuleLoader-NODE_PATH-test": 544,
	"./__tests__/HasteModuleLoader-NODE_PATH-test.js": 544,
	"./__tests__/HasteModuleLoader-currentTestPath-test": 545,
	"./__tests__/HasteModuleLoader-currentTestPath-test.js": 545,
	"./__tests__/HasteModuleLoader-genMockFromModule-test": 546,
	"./__tests__/HasteModuleLoader-genMockFromModule-test.js": 546,
	"./__tests__/HasteModuleLoader-getTestEnvData-test": 547,
	"./__tests__/HasteModuleLoader-getTestEnvData-test.js": 547,
	"./__tests__/HasteModuleLoader-hasDependency-test": 548,
	"./__tests__/HasteModuleLoader-hasDependency-test.js": 548,
	"./__tests__/HasteModuleLoader-requireMock-test": 549,
	"./__tests__/HasteModuleLoader-requireMock-test.js": 549,
	"./__tests__/HasteModuleLoader-requireModule-test": 550,
	"./__tests__/HasteModuleLoader-requireModule-test.js": 550,
	"./__tests__/HasteModuleLoader-requireModuleOrMock-test": 551,
	"./__tests__/HasteModuleLoader-requireModuleOrMock-test.js": 551,
	"./__tests__/NODE_PATH_dir/RegularModuleInNodePath": 552,
	"./__tests__/NODE_PATH_dir/RegularModuleInNodePath.js": 552,
	"./__tests__/test_root/ManuallyMocked": 553,
	"./__tests__/test_root/ManuallyMocked.js": 553,
	"./__tests__/test_root/ModuleWithSideEffects": 554,
	"./__tests__/test_root/ModuleWithSideEffects.js": 554,
	"./__tests__/test_root/NativeModule.node": 1501,
	"./__tests__/test_root/RegularModule": 555,
	"./__tests__/test_root/RegularModule.js": 555,
	"./__tests__/test_root/__mocks__/ExclusivelyManualMock": 556,
	"./__tests__/test_root/__mocks__/ExclusivelyManualMock.js": 556,
	"./__tests__/test_root/__mocks__/ManuallyMocked": 557,
	"./__tests__/test_root/__mocks__/ManuallyMocked.js": 557,
	"./__tests__/test_root/subdir1/MyModule": 558,
	"./__tests__/test_root/subdir1/MyModule.js": 558,
	"./__tests__/test_root/subdir1/__mocks__/MyModule": 559,
	"./__tests__/test_root/subdir1/__mocks__/MyModule.js": 559,
	"./__tests__/test_root/subdir2/MyModule": 560,
	"./__tests__/test_root/subdir2/MyModule.js": 560,
	"./__tests__/test_root/subdir2/__mocks__/MyModule": 561,
	"./__tests__/test_root/subdir2/__mocks__/MyModule.js": 561
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 387;



//////////////////
// WEBPACK FOOTER
// ./~/jest-cli/src/HasteModuleLoader ^\.\/.*$
// module id = 387
// module chunks = 0